var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"width":"1200px"}},[_c('EmployeePayrollView',{ref:"employeePayrollView",attrs:{"user":_vm.user,"companies":_vm.companiesList,"mySubmissions":_vm.mySubmissions},on:{"submit":_vm.handlePayrollSubmission,"refresh":_vm.loadEmployeeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }